<template lang="pug">
  section.font-sabon
    .text-24.leading-none.text-center
      h1(v-if="title") {{title}}
    //- column
    section.md-w-xl.mx-auto.pt-60.md-pt-50.pb-px
      //- grid body
      .px-10.md-w-grid-40.md--ml-40.md-px-20.flex.flex-wrap.items-end.justify-center
        //- articles list
        article.relative.w-1x2.sm-w-1x3.md-w-1x4.lg-w-1x5.px-5.md-px-20.hover-text-blue(v-for="article in articles")
          article-link.hover-text-blue.hover-scale-figure(:to="rt(article)")
            figure
              resp-img.block.w-full(v-if="img(article)", :lazy="true", :src="img(article).source_url", :alt="img(article).alt")
            //- header is also the bottom margin (so image bottoms align)
            h4.h-140.hover-text-black.text-14.leading-sm.text-center
              span.inline-block.pt-15.hover-text-blue(v-html="article.acf.title_on_index || article.title.rendered")
</template>

<script>
import RespImg from '@/components/RespImg'
import ArticleLink from '@/components/ArticleLink'
import _get from 'lodash/get'
export default {
  name: 'ArticlesFeed',
  props: ['title', 'articles'],
  methods: {
    rt (article) {
      return !article ? '' : { name: 'article', params: { slug: article.slug } }
    },
    img (article) {
      return _get(article, "_embedded['wp:featuredmedia'][0]")
    }
  },
  components: { RespImg, ArticleLink }
}
</script>

<style>
</style>
